import CostBreakdownChart from '@/components/charts/CostBreakdownChart';
import AnalysisContainer from '@/components/core/AnalysisContainer';
import AnalysisBox from '@/components/core/AnalysisBox';
import { useNodeById, useTEAPlot } from '@/stores/analysisStore';
import { getTEAYaxisLabel, parseLCABreakdownFormData, parsePathwayCostBreakdownData } from '@/utils/analysisUtils';

const TEABreakdownPlot = () => {
  const plot = useTEAPlot();
  const { nodeId, feedstock_costs = [], pathway_cost_breakdown, upstreamCostsBreakdown } = plot;
  const node = useNodeById(nodeId);

  if (!upstreamCostsBreakdown) {
    return null;
  }

  const results = parseLCABreakdownFormData(feedstock_costs);

  const unit = getTEAYaxisLabel(plot, node, false);

  return (
    <AnalysisContainer title="TEA Cost Breakdown">
      <AnalysisBox>
        <div className="flex flex-col gap-8">
          <CostBreakdownChart
            breakdownResults={results ?? []}
            yAxisLabel={`Feedstock Breakdown - ${node.label}\n[${unit}]`}
            digits={2}
            unit={unit}
          />
          {pathway_cost_breakdown && (
            <CostBreakdownChart
              breakdownResults={parsePathwayCostBreakdownData(pathway_cost_breakdown)}
              yAxisLabel={`Pathway Cost Breakdown - ${node.label}\n[${unit}]`}
              digits={2}
              unit={unit}
              itemLabel="Module"
            />
          )}
        </div>
      </AnalysisBox>
    </AnalysisContainer>
  );
};

export default TEABreakdownPlot;
